import { useMutation } from '@apollo/client/react';
import { useLayoutEffect } from 'react';

import { urlBase64ToUint8Array } from "../../../common/urlBase64ToUint8Array";
import { DEVICE, WEB_PUSH_PUBLIC_KEY } from '../../../config';

import AddPushSubscriptionMutation from './AddPushSubscriptionMutation.graphql';

const isBrowserCompatible = typeof window.Notification !== 'undefined' && 'serviceWorker' in navigator;

const WebPushNotificationsHandler = ['WEB'].includes(DEVICE) && isBrowserCompatible && WEB_PUSH_PUBLIC_KEY ? ({ enabled = true }) => {
    const [addPushSubscriptionMutation] = useMutation(AddPushSubscriptionMutation);

    useLayoutEffect(() => {
        const execute = async () => {
            // Ask for notifications permissions
            if (enabled) {
                await Notification.requestPermission();
            }

            // When service worker is ready
            const registration = await navigator.serviceWorker.ready;

            // Enabled: Subscribe to push notifications
            if (enabled) {
                const subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(WEB_PUSH_PUBLIC_KEY),
                });

                // Send to backend
                await addPushSubscriptionMutation({
                    variables: {
                        input: {
                            type: "WEB_PUSH",
                            subscription: JSON.stringify(subscription),
                        }
                    }
                });
            }

            // Not enabled: Unsubscribe to push notifications
            if (!enabled) {
                try {
                    const subscription = await registration.pushManager.getSubscription();
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                } catch (err) {
                    console.error('Error while unsubscribing from push notifications', err);
                }
            }
        };

        execute();
    }, [enabled, addPushSubscriptionMutation]);
} : () => null;

export default WebPushNotificationsHandler;
